'use client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Button as BaseButton } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'

import { PageWidth } from '@/components/PageWidth'

export const ListingsOuterContainer = styled(PageWidth)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1.5rem;
  margin: 1rem auto 2rem;

  @media ${Breakpoints.max.medium} {
    flex-direction: column;
    margin: 0 auto;
  }
`

export const FiltersBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  @media ${Breakpoints.max.medium} {
    width: 100%;
    padding: 0;
  }
`

export const ListingsInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-grow: 1;
  min-width: 0; // prevents child content that is too wide (possible with AppliedFilters#ScrollContainer) from stretching the width

  @media ${Breakpoints.max.medium} {
    width: 100%;
  }
`

export const ResultsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  @media ${Breakpoints.max.small} {
    flex-wrap: wrap;
    row-gap: 0.75rem;
  }
`

export const SearchSortControls = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
`

export const TotalListings = styled.h1`
  ${Typography.Title3}
  flex-shrink: 0;
`

export const SortContainer = styled.div`
  flex-shrink: 0;
`

export const FiltersButton = styled(BaseButton)`
  line-height: 1rem;
  padding: 0.5625rem;
`

export const FiltersButtonIcon = styled(FontAwesomeIcon)`
  font-size: 0.75rem;
`

export const FiltersIcon = styled(FontAwesomeIcon)`
  font-size: 1rem;
`

export const PaginationWrapper = styled.div`
  > div {
    margin: 1rem 0 0;
  }
`
